// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.change-password-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  background: linear-gradient(135deg, #1a1c1e, #252b32, #323b45);
}

.card-container {
  width: 100%;
  max-width: 400px;
  background-color: #1a1c1e;
  border-radius: 16px;
  padding: 30px;
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.2);
  text-align: center;
}

h2 {
  color: #ebebeb;
  margin-bottom: 25px;
  font-size: 24px;
}

.change-password-form {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.input-container {
  position: relative;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: rgb(67, 67, 67);
  border-radius: 8px;
  border: 1px solid #242323;
  padding: 0 12px;
  box-sizing: border-box;
  height: 48px;
  color: #ffff;
}

.input-container input {
  flex: 1 1;
  border: none;
  outline: none;
  color: #ffff;
  font-size: 15px;
  height: 100%;
  background-color: transparent;
  padding-right: 8px;
}

.input-container input::placeholder {
  color: #ddd8d8;
  opacity: 1;
}

.eye-icon {
  font-size: 18px;
  color: #d2cece;
  cursor: pointer;
  min-width: 24px;
  text-align: center;
}

.eye-icon:hover {
  color: #3289c9;
}

.error-text {
  color: #e74c3c;
  font-size: 14px;
  text-align: left;
  margin-top: -10px;
  margin-bottom: 10px;
}

.submit-button {
  background: #2d6791;
  padding: 12px !important;
  border: none;
  border-radius: 8px;
  font-size: 16px;
  color: white;
  font-weight: bold;
  cursor: pointer;
  transition: background 0.3s ease;
}

.submit-button:hover {
  background: #276b99;
}

/* ─────────────── MEDIA QUERIES ─────────────── */

@media (max-width: 768px) {
  .card-container {
    padding: 50px 20px;
    display: flex;
    margin: 10px;
    flex-direction: column;
  }

  h2 {
    font-size: 22px;
  }

  .submit-button {
    font-size: 15px;
  }
}

@media (max-width: 480px) {
  .card-container {
    padding: 50px 20px;
    display: flex;
    margin: 10px;
    flex-direction: column;
  }

  .input-container {
    height: 44px;
  }

  input {
    font-size: 14px;
  }

  h2 {
    font-size: 20px;
  }

  .submit-button {
    font-size: 14px;
    padding: 10px !important;
  }

  .eye-icon {
    font-size: 16px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/views/changePassword/ChangePassword.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,8DAA8D;AAChE;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,yCAAyC;EACzC,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,iCAAiC;EACjC,kBAAkB;EAClB,yBAAyB;EACzB,eAAe;EACf,sBAAsB;EACtB,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,aAAa;EACb,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,6BAA6B;EAC7B,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;EACf,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,wBAAwB;EACxB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA,kDAAkD;;AAElD;EACE;IACE,kBAAkB;IAClB,aAAa;IACb,YAAY;IACZ,sBAAsB;EACxB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,kBAAkB;IAClB,aAAa;IACb,YAAY;IACZ,sBAAsB;EACxB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,wBAAwB;EAC1B;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":[".change-password-container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 100vh;\n  background: linear-gradient(135deg, #1a1c1e, #252b32, #323b45);\n}\n\n.card-container {\n  width: 100%;\n  max-width: 400px;\n  background-color: #1a1c1e;\n  border-radius: 16px;\n  padding: 30px;\n  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.2);\n  text-align: center;\n}\n\nh2 {\n  color: #ebebeb;\n  margin-bottom: 25px;\n  font-size: 24px;\n}\n\n.change-password-form {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n\n.input-container {\n  position: relative;\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  background-color: rgb(67, 67, 67);\n  border-radius: 8px;\n  border: 1px solid #242323;\n  padding: 0 12px;\n  box-sizing: border-box;\n  height: 48px;\n  color: #ffff;\n}\n\n.input-container input {\n  flex: 1;\n  border: none;\n  outline: none;\n  color: #ffff;\n  font-size: 15px;\n  height: 100%;\n  background-color: transparent;\n  padding-right: 8px;\n}\n\n.input-container input::placeholder {\n  color: #ddd8d8;\n  opacity: 1;\n}\n\n.eye-icon {\n  font-size: 18px;\n  color: #d2cece;\n  cursor: pointer;\n  min-width: 24px;\n  text-align: center;\n}\n\n.eye-icon:hover {\n  color: #3289c9;\n}\n\n.error-text {\n  color: #e74c3c;\n  font-size: 14px;\n  text-align: left;\n  margin-top: -10px;\n  margin-bottom: 10px;\n}\n\n.submit-button {\n  background: #2d6791;\n  padding: 12px !important;\n  border: none;\n  border-radius: 8px;\n  font-size: 16px;\n  color: white;\n  font-weight: bold;\n  cursor: pointer;\n  transition: background 0.3s ease;\n}\n\n.submit-button:hover {\n  background: #276b99;\n}\n\n/* ─────────────── MEDIA QUERIES ─────────────── */\n\n@media (max-width: 768px) {\n  .card-container {\n    padding: 50px 20px;\n    display: flex;\n    margin: 10px;\n    flex-direction: column;\n  }\n\n  h2 {\n    font-size: 22px;\n  }\n\n  .submit-button {\n    font-size: 15px;\n  }\n}\n\n@media (max-width: 480px) {\n  .card-container {\n    padding: 50px 20px;\n    display: flex;\n    margin: 10px;\n    flex-direction: column;\n  }\n\n  .input-container {\n    height: 44px;\n  }\n\n  input {\n    font-size: 14px;\n  }\n\n  h2 {\n    font-size: 20px;\n  }\n\n  .submit-button {\n    font-size: 14px;\n    padding: 10px !important;\n  }\n\n  .eye-icon {\n    font-size: 16px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
